// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export const LoginConfig = {
    // indexPageURL: 'http://localhost:8000/bifrost',
    indexPageURL: process.env.REACT_APP_INDEX_PAGE_URL,
    apiBaseURL: process.env.REACT_APP_API_ENDPOINT_PREFIX
};
